<template>
  <ul class="font-family text-start">

    <li v-for="(menu, index) in filteredMenus" :key="index" class="sub-menu-item" style="cursor: pointer;"
      @click="handleClick(menu)">

      <label class="text-decoration-none font-color" style="cursor: pointer;">{{ menu.label }}</label>
      <div class="caret"></div>
    </li>

  </ul>
</template>

<script>
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js';

export default {
  name: "MenuMobile",
  data() {
    return {
      data_agent_requests: [],
      showAgentRenewLicense: false,
      showAgentRenewLicenseAdditionalDoc: false,
      menus: [
        { label: 'ขอเปลี่ยนแปลงข้อมูลตัวแทน', action: 'Authentication', subjob: '', path: '/AgentInfo', code: null },
        { label: 'ขอเปลี่ยนแปลงเบอร์มือถือ', action: 'Authentication', subjob: '', path: '/EditMobilePhone', code: null },
        { label: 'ขอเปลี่ยนแปลงอีเมล', action: 'Authentication', subjob: '', path: '/EditEmail', code: null },
        { label: 'ขอเปลี่ยนแปลงข้อมูล Social Media', action: 'Authentication', subjob: '', path: '/SocialMediaInfo', code: null },
        { label: 'ขอแต่งตั้งตำแหน่ง (ผู้บริหารหน่วยดำเนินการ)', action: 'Permission', subjob: '', path: '/AssignPosition', code: null },
        { label: 'ขอเปลี่ยนแปลงตำแหน่ง (ผู้บริหารหน่วยดำเนินการ)', action: 'Permission', subjob: '', path: '/ChangePosition', code: null },
        { label: 'ขอโอนตัวแทนใต้สังกัด (ผู้บริหารหน่วยดำเนินการ)', action: 'Permission', subjob: '', path: '/TransferAgent', code: null },
        { label: 'ขอย้ายสาขา (ผู้บริหารหน่วยดำเนินการ)', action: 'Permission', subjob: '', path: '/ManagerChangeBranch', code: null },
        { label: 'ขอย้ายสาขา (ตัวแทนดำเนินการ)', action: 'Authentication', subjob: 'B01', path: '/ChangeBranch', code: null },
        { label: 'ขอโอนผลงาน', action: 'Authentication', subjob: this.$store.state.POL_TRAN.SUBJOB, path: '/TranferWork', code: null },
        { label: 'ขอหนังสือรับรองการทำงาน', action: 'Authentication', subjob: '', path: '/RequestCert', code: null },
        { label: 'ขอพิมพ์นามบัตร', action: 'Authentication', subjob: this.$store.state.CARD_PRINT.SUBJOB, path: '/PrintCard', code: null },
        { label: 'ขอลาออก', action: 'Authentication', subjob: this.$store.state.RESIGN_MEMO.SUBJOB, path: '/Resignation', code: null },
        { label: 'ขอต่ออายุใบอนุญาต', action: 'Authentication', subjob: 'L01', path: '/AgentRenewLicense', code: null, flag: 'showAgentRenewLicense' },
        { label: 'ส่งเอกสารเพิ่มเติม ยื่นขอต่ออายุใบอนุญาต', action: 'Authentication', subjob: '', path: '/AgentRenewLicenseAdditionalDoc', code: null, flag: 'showAgentRenewLicenseAdditionalDoc' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอเปลี่ยนแปลงข้อมูล ชื่อ - นามสกุล(ภาษาอังกฤษ)', action: 'Authentication', subjob: '', path: '/ChangeNameEN', code: 2, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอเปลี่ยนแปลงข้อมูล ที่อยู่', action: 'Authentication', subjob: '', path: '/ChangeAddr', code: 5, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอเปลี่ยนแปลงข้อมูล บัญชีธนาคาร', action: 'Authentication', subjob: '', path: '/ChangeAccBank', code: 6, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอเปลี่ยนแปลงข้อมูล บันทึก VAT', action: 'Authentication', subjob: '', path: '/ChangeVat', code: 7, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอแต่งตั้งตำแหน่ง(ผู้บริหารหน่วยดำเนินการ)', action: 'Authentication', subjob: '', path: '/AppointOperationExecutive', code: 12, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอเปลี่ยนแปลงตำแหน่ง (ผู้บริหารหน่วยดำเนินการ)', action: 'Authentication', subjob: '', path: '/OperationExecutivePromotion', code: 14, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอเปลี่ยนแปลงตำแหน่ง (ผู้บริหารหน่วยดำเนินการ)', action: 'Authentication', subjob: '', path: '/OperationExecutiveDowngrade', code: 13, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอโอนตัวแทนใต้สังกัด(ผู้บริหารหน่วยดำเนินการ)', action: 'Authentication', subjob: '', path: '/TransferSubAgentOperationExecutive', code: 11, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม แจ้งย้ายสาขา(ผู้บริหารหน่วยดำเนินการ)', action: 'Authentication', subjob: '', path: '/BranchTransferOperationExecutive', code: 10, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอย้ายสาขา(ตัวแทนดำเนินการ)', action: 'Authentication', subjob: '', path: '/BranchTransferOperationAgent', code: 9, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอโอนผลงาน', action: 'Authentication', subjob: '', path: '/TransferPerformance', code: 15, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอหนังสือรับรองการทำงานภาษาไทย', action: 'Authentication', subjob: '', path: '/ReqAgentCertTH', code: 16, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอหนังสือรับรองการทำงานภาษาอังกฤษ (แบบไม่ระบุรายได้)', action: 'Authentication', subjob: '', path: '/ReqAgentCertENNoIncome', code: 17, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้ของปีนี้ และปีที่แล้ว)', action: 'Authentication', subjob: '', path: '/ReqAgentCertENIncome2Years', code: 18, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้เฉพาะของปีนี้)', action: 'Authentication', subjob: '', path: '/ReqAgentCertENIncomeCurrent', code: 19, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอพิมพ์นามบัตร', action: 'Authentication', subjob: '', path: '/ReqAgentBusinessCard', code: 21, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอลาออก', action: 'Authentication', subjob: '', path: '/ReqAgentResignation', code: 22, flag: '' },
        
        { label: 'ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน', action: 'Authentication', subjob: 'F01', path: '/BuildingAccessCard', code: null, flag: '' },
        { label: 'ส่งเอกสารเพิ่มเติม ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน', action: 'Authentication', subjob: '', path: '/BACAdditionalDoc', code: 78, flag: '' },
      ],
    };
  },
  computed: {
    filteredMenus() {
      return this.menus.filter(menu => this.checkMenu(menu))
    }
  },
  async mounted() {
    if (this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    await this.manageAgentRequests();
    await this.checkLicenseNearExpiry();
  },
  methods: {
    checkMenu(menu) {
      // case ใช้ flag
      if (menu.flag) {
        return this[menu.flag]
      }

      // case ใช้ code
      if (menu.code) {
        const data = this.$store.state.data_agent_requests || []

        return data.some(x =>
          x.REQUEST_CODE_ID == menu.code &&
          x.STATUS == '001' &&
          x.SUB_STATUS == 'S13'
        )
      }

      return true
    },
    handleClick(menu) {
      this[menu.action](menu.path, menu.subjob || '')
    },
    checkLicenseNearExpiry() {
      const AuthorizeToken = localStorage.getItem("AuthorizeToken");
      // สำคัญ: return Promise นี้ออกไป
      return http
        .get(`AgencyERequest/CanRequestLicenseRenewal`, {
          headers: { Authorization: `Bearer ${AuthorizeToken}` }
        })
        .then((response) => {
          if (response.status === 200) {
            this.showAgentRenewLicense = (!response.data.isCanRequest && response.data.isHideMenu) ? false : true;
          } else {
            Swal.fire({
              icon: 'error',
              html: '<label class="fs-4 fw-normal font-family">ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง</label>',
            });
          }
        })
        .catch((error) => {
          console.error(error);

          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง</label>',
          });
        });
    },
    manageAgentRequests() {
      this.data_agent_requests = this.$store.state.data_agent_requests;

      if (this.data_agent_requests.length === 0) {
        this.showAgentRenewLicense = true;
        this.showAgentRenewLicenseAdditionalDoc = false;
        return;
      }

      // มีเอกสารต่ออายุแต่ปิดเคสแล้ว หรือเป็นเอกสารอื่นที่ไม่ใช่ต่ออายุ
      this.showAgentRenewLicense = this.data_agent_requests.some(
        x =>
          (x.REQUEST_CODE_ID === 36 && x.STATUS !== '001' && x.STATUS !== '002') ||
          (x.REQUEST_CODE_ID !== 36)
      );

      // เคสต้องแนบเอกสารเพิ่มเติม
      this.showAgentRenewLicenseAdditionalDoc = this.data_agent_requests.some(
        x => (x.REQUEST_CODE_ID === 36 && x.STATUS === '001' && x.SUB_STATUS === 'S13')
      );
    },
    Authentication(To, SUBJOB) {
      if (SUBJOB === '') {
        this.$router.push(To);
      }
      else {
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
        let request = {
          AGENTCODE: [],
          SUBJOB: SUBJOB
        };
        http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
          if (res.data !== '001' && res.data !== '002') {
            this.$router.push(To);
          }
          else {
            Swal.fire({
              icon: 'error',
              html: '<lable class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</lable>',
            });

            this.$router.push("/AgenteService");
          }

        }).catch((error) => {
          console.error(error);

          Swal.fire({
            icon: 'error',
            html: '<lable class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดของระบบ</lable>',
          });
          this.$router.push("/AgenteService");
        });
      }
    },
    Permission(To, SUBJOB) {
      // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");
      http.get("AgencyERequest/GetName?", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
        if (res.status == 200) {
          this.$store.state.UserName = res.data.NAME + " " + res.data.SURNAME;
          this.$store.state.User_AG_STLV_SP = res.data.AG_STLV_SP;
          this.$store.state.User_AG_STATUS = res.data.AG_STATUS;
          this.$store.state.User_AG_LEVEL = res.data.AG_LEVEL;
          this.$store.state.User_AGENTTYPE = res.data.AGENTTYPE;

          if (res.data.AG_LEVEL >= '02') {
            if (SUBJOB === '') {
              this.$router.push(To);
            }
            else {
              let request = {
                AGENTCODE: [],
                SUBJOB: SUBJOB
              };

              http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
                if (res.status == 200) {
                  if (res.data !== '001' && res.data !== '002') {
                    this.$router.push(To);
                  }
                  else {
                    Swal.fire({
                      icon: 'error',
                      html: '<lable class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</lable>',
                    });

                    this.$router.push("/AgenteService");
                  }
                }
              }).catch((error) => {
                console.error(error);

                Swal.fire({
                  icon: 'error',
                  html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                  window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                });
              });
            }
          }
          else {
            Swal.fire({
              icon: 'error',
              html: '<lable class="fs-4 fw-normal font-family">สำหรับผู้บริหารหน่วยดำเนินการเท่านั้น</lable>',
            });
            this.$router.push("/AgenteService");
          }
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
        }).then(() => {
          localStorage.removeItem("Token");
          localStorage.removeItem("AuthorizeToken");
          window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
        });
      });
    }
  },
};
</script>

<style scoped>
.font-color {
  color: #0057a8;
  text-align: initial;
}

.sub-menu-item {
  border-bottom: 1px solid #dedede;
  font-size: 22px;
  font-size: 1.375rem;
  position: relative;
  padding: 1rem 1rem;
  display: block;
}

.caret {
  background-image: url(@/assets/images/arrow-blue.svg);
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 45%;
  width: 16px;
  height: 25px;
  cursor: pointer;
  display: block;
  position: absolute;
  right: 14px;
  top: 15px;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}
</style>